import Cookies from "js-cookie";

export default (basketId) => {
    // Set the basketId for future usage.
    Cookies.set("basket_id", basketId, {
        expires: 30,
    });
};
